<template>
	<div>
		<div class="btns-top">
			<router-link to="/settings/languages/add" class="btn btn-add fa fa-plus transition-fadeinup transition-delay-01"></router-link>
		</div>

		<table cellpadding="0" cellspacing="0" class="data transition-fadeinup">
			<thead>
			<tr>
				<th></th>
				<th><h2>Language</h2></th>
				<th>Path prefix </th>
				<th>Online</th>
				<th></th>
				<th></th>
			</tr>
			</thead>

			<tbody class="draggable-container">

				<tr v-for="market in markets" :key="market.id" :data-locale="market.locale">
					<td class="handle">
						<div class="grip"></div>
					</td>
					<td>
						{{market.language}}
					</td>
					<td>
						{{market.locale}}
					</td>
					<td>
						<a href="#" class="btn-switch" :class="{ 'active' : market.state === 3 }" :data-toggle-id="`${market.id}`" v-on:click="toggleClickHandler"></a>
					</td>
					<td class="btns">
						<a href="#" v-on:click="btnPrivilegesClickHandler" :data-id="market.id"><i class="fa fa-lock"></i></a>
						<a href="#" class="btn-delete-confirm fa fa-trash-alt" :id="market.id"></a>
					</td>
					<td></td>
				</tr>

			</tbody>
		</table>

		<Sidebar :type="'privileges'" ref="sidebar" :data="dataWrapper"></Sidebar>

		<!-- <div class="row">
			<div class="col-20 transition-fadeinup transition-delay-02">

				<p>&nbsp;</p>
				<p>&nbsp;</p>

				<h2>Show language prefix in url</h2>
				<p>The prefix will be forced when there is more as one language enabled.</p>
				<form>
					<ul>
						<li><label class="flex-label"><input type="checkbox" class="toggle" checked> Show language prefix in url</label></li>
					</ul>
				</form>

				<p>&nbsp;</p>

				<h2>Autodetect browser language</h2>
				<p>Use the most prefered available language of the client browser as default.</p>
				<form>
					<ul>
						<li><label class="flex-label"><input type="checkbox" class="toggle" checked> Autodetect browser language</label></li>
					</ul>
				</form>

			</div>
		</div> -->

		<div class="bubble bubble-delete-confirm">
			<a href="" class="btn red btn-bubble-delete" v-on:click="deleteRecord">Confirm</a>
			<a href="" class="btn black btn-bubble-cancel">Cancel</a>
		</div>
	</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'
import sortable from '../../modules/sortable.js'
import Sidebar from '../../components/sidebars/Sidebar.vue'

export default {
	name: 'languages',
	components: {
		'Sidebar': Sidebar
	},
	data () {
		return {
			markets: null,
			dataWrapper: {
				marketOffsetTop: null,
				sidebarlang: null,
				data: null,
				marketData: null
			}
		}
	},

	created () {
		this.fetchData()
	},

	updated () {
		this.sortableModule = sortable({
			container: null,
			type: 'languages',
			callback: this.sortEnded.bind(this)
		})
		this.sortableModule.init()
	},

	methods: {
		fetchData () {
			var url = '/cms/api/markets'
			xhrModule.get(url, this.getContentCompleteHandler.bind(this))
		},

		getContentCompleteHandler (data) {
			data = data.data

			// don't show the cms language with ID 1
			for (var lang in data) {
				if (data[lang].id === 1) delete data[lang]
			}

			// sort markets based on priority
			data = Object.values(data)
			data.sort((a, b) => (a.priority > b.priority) ? 1 : -1)

			this.markets = data
		},

		sortEnded () {
			var container = document.querySelectorAll('.draggable-container tr')
			var localeOrder = []
			for (var i = 0; i < container.length; i++) {
				var locale = container[i].getAttribute('data-locale')
				localeOrder.push(locale)

				if (i === container.length - 1) {
					// make a post for each market with the correct priority
					this.postMarketPriorities(localeOrder)
				}
			}
		},

		postMarketPriorities (localeOrder) {
			var url = '/cms/api/markets'
			for (var i = 0; i < localeOrder.length; i++) {
				// find the correct market for this locale

				for (var key in this.markets) {
					if (this.markets[key].locale === localeOrder[i]) {
						this.markets[key].priority = i + 1

						var json = JSON.stringify(this.markets[key])
						xhrModule.post(url, json, this.marketPostCompleted.bind(this))
					}
				}
			}
		},

		marketPostCompleted (data) {
			console.log('post completed: ', data)
		},

		btnPrivilegesClickHandler (e) {
			e.preventDefault()

			var id = e.currentTarget.getAttribute('data-id')
			var market = null
			for (var i = this.markets.length - 1; i >= 0; i--) {
				if (this.markets[i].id == id) {
					market = this.markets[i]
				}
			}

			// find the offset top for the marker in the sidebar
			this.dataWrapper.marketOffsetTop = e.currentTarget.getBoundingClientRect().top + (e.currentTarget.getBoundingClientRect().height / 2) - 9

			// set instance as data
			this.dataWrapper.marketData = market

			this.$refs.sidebar.toggle(e.currentTarget)
		},

		toggleClickHandler (e) {
			e.preventDefault()

			var marketId = e.currentTarget.getAttribute('data-toggle-id')

			for (var i = this.markets.length - 1; i >= 0; i--) {
				if (this.markets[i].id == marketId) {
					if (this.markets[i].state > 1) {
						this.markets[i].state = 1
					} else {
						this.markets[i].state = 3
					}

					// post this value
					var json = JSON.stringify(this.markets[i])
					var url = '/cms/api/markets'
					xhrModule.post(url, json, this.updateStateMarketCompleteHandler.bind(this))
				}
			}
		},

		updateStateMarketCompleteHandler (data) {
		},

		deleteRecord (e) {
			e.preventDefault()

			var target = e.currentTarget
			var uuid = target.getAttribute('data-id')

			// find market to delete and set state to 5
			for (var i = this.markets.length - 1; i >= 0; i--) {
				if (this.markets[i].id == uuid) {
					this.markets[i].state = 5

					var json = JSON.stringify(this.markets[i])

					var url = '/cms/api/markets'
					xhrModule.post(url, json, this.deleteMarketCompleteHandler.bind(this))
				}
			}
		},

		deleteMarketCompleteHandler (data) {
			this.fetchData()
		}
	}
}

</script>
